import React, { useState } from 'react';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { useSelector } from 'react-redux';
import { reactTableSortOnClickInFuncComp, getMatchingSwVersions, removeSpaces } from 'common/utils/helpers';
import { ReactTableFixedColumns } from '../../shared/ReactTable';
import Dropdown from 'components/shared//Dropdown/Dropdown';
import { LOADING_CIRCLE } from 'common/utils/constants';
import './DefaultSWVersionTable.css';

export const DefaultSWVersionTable = (props) => {
  const { fetching, parent, error, data, dispatch, swDefaultSwVersionWritePermission, productTypesList } = props;

  const allSWVersions = useSelector((store) => store?.data?.softwareVersions?.all);

  let availableSWVersionList = [];
  let [sorted, setSorted] = useState([
    {
      id: 'actions_dateTime_col_id',
      desc: true
    }
  ]);

  let overlay = null;
  if (error && (data == null || data.length === 0)) {
    overlay = (
      <div className="Global_Table_ErrorOverlay">
        <div className="Global_Table_Error_Div">
          <div className="Global_Table_ErrorOverlay_Title">Error </div>
          <div className="Global_Table_ErrorOverlay_Message">
            An unexpected problem occurred and this data is unavailable. Please try refreshing the page, and if the
            problem persists, contact us at
            <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
          </div>
        </div>
      </div>
    );
  }

  const columns = (parent) => [
    {
      minWidth: 60,
      Header: (row) => {
        let deviceColHeader = 'Device Type';
        return (
          <div className="DeviceTable_Header_OuterDiv">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={deviceColHeader}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'type_col_id')}
            />
            <div className="DeviceTableHeader_ResizerSliderIcon">
              <div className="DeviceTableHeader_ResizerSliderIcon_Bar"></div>
            </div>
          </div>
        );
      },
      id: 'type_col_id',
      accessor: (device) => {
        return device;
      },
      Cell: (row) => {
        let deviceTypeList = [row.value.deviceType];
        let deviceItems =
          deviceTypeList &&
          deviceTypeList.map((member, index) => {
            if (member === 'Echo5G') {
              member = 'Echo 5G';
            } else if (member === 'Pivot5G') {
              member = 'Pivot 5G';
            }
            return (
              <div className="DeviceTable_Header_OuterDiv" key={index}>
                {member}
              </div>
            );
          });
        return deviceItems;
      },
      sortMethod: (a, b) => {
        return a.deviceType.toLowerCase() > b.deviceType.toLowerCase() ? 1 : -1;
      }
    },
    {
      Header: (col) => {
        return (
          <div className="DeviceTable_Header_OuterDiv">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'SW Version'}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'sw_version')}
            />
            {/* <div className="DeviceTableHeader_ResizerSliderIcon">
              <div className="DeviceTableHeader_ResizerSliderIcon_Bar"></div>
            </div> */}
          </div>
        );
      },
      id: 'sw_version',
      resizable: false,
      accessor: (device) => {
        return device;
      },
      Cell: (row) => {
        let defaultSwVersionId = row.original?.id;
        let swVersionList = [row.value?.defaultSWVersion];
        let ddDefaultSWVersion = null;
        let deviceIndex = '';
        let [transferSelection, setTransferSelection] = useState(ddDefaultSWVersion);
        // eslint-disable-next-line no-unused-vars
        let [transferIndex, setTransferIndex] = useState(deviceIndex);
        let translatedDeviceType = removeSpaces(row.value?.deviceType)?.toLowerCase();

        if (translatedDeviceType === 'echo5g') {
          translatedDeviceType = 'ES3_28';
          ddDefaultSWVersion = row.value?.defaultSWVersion;
          deviceIndex = 1;
        } else if (translatedDeviceType === 'pivot5g') {
          ddDefaultSWVersion = row.value?.defaultSWVersion;
          deviceIndex = 0;
        }

        availableSWVersionList = ['No Default'];
        let availableSwVersionsObj = getMatchingSwVersions(null, allSWVersions, productTypesList, translatedDeviceType);

        availableSwVersionsObj &&
          Object.keys(availableSwVersionsObj).forEach((sw) => {
            availableSWVersionList.push(availableSwVersionsObj?.[`${sw}`]?.sw_version);
          });

        let swVersionItems =
          swVersionList &&
          swVersionList.map((member, index) => {
            return (
              <div className="DefaultSWVersion_Header_OuterDiv" key={index}>
                <div className="DefaultSWVersion_CellWrapper">
                  <span className="DefaultSWVersion_Span">{member}</span>
                  {swDefaultSwVersionWritePermission && (
                    <Dropdown
                      dispatch={dispatch}
                      isRadioButton={true}
                      showItems={availableSWVersionList.length}
                      data={availableSWVersionList}
                      defaultSwVersionId={defaultSwVersionId}
                      isChecked={ddDefaultSWVersion}
                      selectItem={transferSelection}
                      sendItem={(selection) => {
                        setTransferSelection(selection);
                      }}
                      sendIndex={() => {
                        setTransferIndex(deviceIndex);
                        return deviceIndex;
                      }}
                    />
                  )}
                </div>
              </div>
            );
          });
        return swVersionItems;
      },
      sortMethod: (a, b) => {
        return a.defaultSWVersion.toLowerCase() > b.defaultSWVersion.toLowerCase() ? 1 : -1;
      }
    }
  ];

  let noDataText = fetching ? (
    LOADING_CIRCLE
  ) : (
    <span className="DefaultSWVersion_Table_NoDataText">No available default software version</span>
  );

  return (
    <div>
      <ReactTableFixedColumns
        className="Global_Table DefaultSWVersion_Table"
        minRows={5}
        showPagination={false}
        fetching={fetching}
        pageSize={data.length}
        overlay={overlay}
        noDataText={noDataText}
        data={data}
        columns={columns(parent)}
        sorted={sorted}
        onSortedChange={(newSorted, column, shiftKey) => {
          setSorted(newSorted);
        }}
      />
    </div>
  );
};
